import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import QuestionCard from './QuestionCard'
import flattenMessages from './flattenMessages'
import { DECORATIVE_CONTEXTS } from './questionTypeLabels'
import CommentMarkField from './fields/CommentMarkField'
import ContentVariableMarkField from './fields/ContentVariableMarkField'
import DateTimeMarkField from './fields/DateTimeMarkField'
import DescriptionMarkField from './fields/DescriptionMarkField'
import MultiSelectMarkField from './fields/MultiSelectMarkField'
import NumericMarkField from './fields/NumericMarkField'
import PdfMarkField from './fields/PdfMarkField'
import PhotosMarkField from './fields/PhotosMarkField'
import PlanMarkField from './fields/PlanMarkField'
import PictureMarkField from './fields/PictureMarkField'
import SelectMarkField from './fields/SelectMarkField'
import SignatureMarkField from './fields/SignatureMarkField'
import TitleMarkField from './fields/TitleMarkField'
import VariableMarkField from './fields/VariableMarkField'

const SELECTION_MULTI = 'selection_multi'
const CONTENT_VARIABLE = 'content_variable'
const PLAN = 'plan'

const FIELDS_BY_CONTEXT = {
  comment: CommentMarkField,
  datetime: DateTimeMarkField,
  numeric: NumericMarkField,
  grade: SelectMarkField,
  selection: SelectMarkField,
  [SELECTION_MULTI]: MultiSelectMarkField,
  variable: VariableMarkField,
  title: TitleMarkField,
  description: DescriptionMarkField,
  picture: PictureMarkField,
  signature: SignatureMarkField,
  photos: PhotosMarkField,
  plan: PlanMarkField,
  pdf: PdfMarkField,
  [CONTENT_VARIABLE]: ContentVariableMarkField
}

const MarkField = ({ mark, readonly, errors, first, onChange }) => {
  const handleChange = useCallback(changes => onChange(mark.id, changes), [mark.id, onChange])
  const Field = FIELDS_BY_CONTEXT[mark.question.context]
  if (!Field)
    return null

  if (DECORATIVE_CONTEXTS.includes(mark.question.context))
    return <Field first={first} mark={mark} />

  const errorMessages = flattenMessages(errors)

  if (mark.question.context === PLAN) {
    return (
      <Field errorMessages={errorMessages} mark={mark} readonly={readonly} onChange={handleChange} />
    )
  }

  return (
    <QuestionCard errorMessages={errorMessages} question={mark.question}>
      <Field mark={mark} readonly={readonly} onChange={handleChange} />
    </QuestionCard>
  )
}

MarkField.propTypes = {
  errors: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
  first: PropTypes.bool,
  mark: PropTypes.shape({
    id: PropTypes.number.isRequired,
    question: PropTypes.shape({
      context: PropTypes.string.isRequired,
      mandatory: PropTypes.bool,
      title: PropTypes.string
    }).isRequired
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  readonly: PropTypes.bool
}

MarkField.defaultProps = {
  errors: {},
  first: false,
  readonly: false
}

export default MarkField
